module.exports = __webpack_public_path__ + "static/media/landskap.eb792714.png";